
import {throwError as observableThrowError} from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { finalize, map, catchError } from 'rxjs/operators';
import { GlobalState } from './global.state';
import { Router } from '@angular/router';


@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private _pendingRequests = 0;
  constructor(
    private _state: GlobalState,
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this._pendingRequests++;
    this._state.notifyDataChanged('[PENDING_REQUEST] UPDATE', this._pendingRequests);
    return next.handle(req).pipe(
      map(event => {
        return event;
      }),
      catchError(error => {
        if ((error.status === 401 || error.status === 403) && (this.router.url !== '/login')) {
          this.router.navigate(['/login']);
        }
        return observableThrowError(error);
      }),
      finalize(() => {
        this._pendingRequests--;
        this._state.notifyDataChanged('[PENDING_REQUEST] UPDATE', this._pendingRequests);
      })
    );
  }
}
